import { Button } from 'antd';
import React from 'react';

const CommonSelectionBar = ({
  selectedCount = 0,
  onClear,
  className = '',
  children,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className={`selection-bar d-flex align-center ${className}`}>
      <div className="selection-info">
        <span className="selection-count">
          {selectedCount} item{selectedCount > 1 ? 's' : ''} selected
        </span>
      </div>

      <div className="selection-divider" />

      {children}

      <Button
        type="text"
        size="small"
        className="clear-button"
        onClick={onClear}
        title="Clear selection"
      >
        ×
      </Button>
    </div>
  );
};

export default CommonSelectionBar;
